import { ODataOptions } from '../util/ODataBuilder';
import BaseApi from './BaseApi';

import ContactInfoModel from '../models/ContactInfo';
import Rate from '../models/Rate';

import LandmanModel from '../models/Landman';
import ManageContactInfo from '../models/forms/ManageContactInfo';
import ManageContactInfoChanges from 'src/models/forms/ManageContactInfoChanges';

export interface ILandman {
    getAll(options: ODataOptions, jwt: string): Promise<object>;
    get(id: number, jwt: string): Promise<object>;
    getRates(landmanId: number, jwt: string): Promise<object>;
    getContactInfo(landmanId: number, jwt: string): Promise<object>;
    updateContactInfo(contactInfo: ContactInfoModel, jwt: string): Promise<object>;
    addLandmanRate(newRate: Rate, jwt: string): Promise<object>;
    create(landman: LandmanModel, jwt: string): Promise<object>;
    saveLandmanContactInfo(contactInfo: ManageContactInfo, jwt: string): Promise<object>;
    saveLandmanContactInfoChanges(landmanId: number, contactInfoChanges: ManageContactInfoChanges, jwt: string): Promise<object>;
}

export default class Landman extends BaseApi implements ILandman {
    private mockLandman: ILandman;

    constructor(baseUrl: string) {
        super(baseUrl);

        this.getAll = this.getAll.bind(this);
        this.get = this.get.bind(this);
        this.create = this.create.bind(this);
        this.getRates = this.getRates.bind(this);
        this.getContactInfo = this.getContactInfo.bind(this);
        this.updateContactInfo = this.updateContactInfo.bind(this);
        this.addLandmanRate = this.addLandmanRate.bind(this);
        this.saveLandmanContactInfo = this.saveLandmanContactInfo.bind(this);
        this.saveLandmanContactInfoChanges = this.saveLandmanContactInfoChanges.bind(this);
    }

    public getAll(options: ODataOptions, jwt: string) {
        return this.getRequest(`${this.baseUrl}v1.0/landmen${options.toString()}`, jwt);
    }

    public get(id: number, jwt: string) {
        return this.getRequest(`${this.baseUrl}v1.0/landmen/${id}`, jwt);
    }

    public getRates(landmanId: number, jwt: string) {
        // return this.mockLandman.getRates(landmanId, jwt);
        return this.getRequest(`${this.baseUrl}v1.0/landmen/${landmanId}/rates`, jwt);
    }

    public getContactInfo(landmanId: number, jwt: string) {
        // return this.getRequest(`${this.baseUrl}v1.0/landmen/${landmanId}/contact-info`, jwt);
        return this.mockLandman.getContactInfo(landmanId, jwt);
    }

    public updateContactInfo(contactInfo: ContactInfoModel, jwt: string) {
        return this.mockLandman.updateContactInfo(contactInfo, jwt);
        // return this.postRequest(`${this.baseUrl}v1.0/landmen/${contactInfo.landmanId}/contact-info`, contactInfo, jwt);
    }

    public addLandmanRate(newRate: Rate, jwt: string) {
        // return this.mockLandman.addLandmanRate(newRate, jwt);
        return this.postRequest(`${this.baseUrl}v1.0/landmen/${newRate.userId}/manage-rates`, newRate, jwt);
    }

    public create(landman: LandmanModel, jwt: string) {
        return this.postRequest(`${this.baseUrl}v1.0/landmen/`, landman, jwt);
    }

    public saveLandmanContactInfo(contactInfo: ManageContactInfo, jwt: string) {
        return this.postRequest(`${this.baseUrl}v1.0/landmen/${contactInfo.landmanId}/save-contact-info`, contactInfo, jwt);
        // return this.mockLandman.saveLandmanContactInfo(contactInfo, jwt);
    }

    public saveLandmanContactInfoChanges(landmanId: number, contactInfoChanges: ManageContactInfoChanges, jwt: string) {
        return this.putRequest(`${this.baseUrl}v1.0/landmen/${landmanId}/save-contact-info-changes`, contactInfoChanges, jwt);
    }
}



// WEBPACK FOOTER //
// ./src/api/Landman.ts